import axios from 'axios'
// import constants from '../../../helpers/constants'
import { isEqual } from '@/helpers/isEqual'

export default {
  state: {
    contactsFormData: {
      name: '',
      lastName: '',
      email: '',
      phone: '',
      city: null,
      recipientName: '',
      recipientLastName: '',
      recipientPhone: '',
      recipientEmail: ''
    },
    invalidFields: {},
    deliveryCities: [],
    isContactFormHidden: false,
    deliveryTypes: [],
    isContactFormEmpty: false,
    lastSelectedCity: null,
    isContactFormValid: true
  },
  getters: {
    isContactFormValid (state) {
      return state.isContactFormValid
    }
  },
  mutations: {
    SET_CONTACTS_FORM (state, data) {
      state.contactsFormData = { ...state.contactsFormData, ...data }
    },
    SET_FORM_VALID (state, data) {
      state.isContactFormValid = data
    },
    SET_INVALID_FIELDS (state, data) {
      state.invalidFields = { ...state.invalidFields, ...data }
    },
    SET_IS_CONTACT_FORM_HIDDEN: (state, data) => {
      state.isContactFormHidden = data
    },
    SET_DELIVERY_TYPES: (state, data) => {
      state.deliveryTypes = data
    },
    SET_DELIVERY_CITIES: (state, cities) => {
      state.deliveryCities = cities
    },
    SET_CONTACT_FORM_EMPTY: (state, bool) => {
      state.isContactFormEmpty = bool
    },
    SET_LAST_SELECTED_CITY (state, cityId) {
      state.lastSelectedCity = cityId
    }
  },
  actions: {
    SET_CONTACTS_FORM_VALID ({ commit, dispatch }, data) {
      commit('SET_FORM_VALID', data)
    },
    SET_CONTACTS_FORM_FIELDS ({ commit, dispatch }, data) {
      commit('SET_CONTACTS_FORM', data)
    },
    SET_CONTACTS_FULL_NAME_ACTION ({ commit, dispatch }, data) {
      const { value, inputType } = data
      const info = {}

      info[inputType] = value
      commit('SET_CONTACTS_FORM', info)
      dispatch('VALIDATE_NAME_AND_LAST_NAME', { value, inputType })
    },
    FETCH_LEGAL_INFO_BY_TAX_NUMBER: async ({ commit, rootGetters, rootState }, data) => {
      if (!data.isVatForm) {
        commit('SET_LOADING_COMPONENTS', { contactsForm: true })
      }
      let result
      await axios
        .get(rootGetters.urlLanguagePrefix + '/shop/cart/legal-info/', { params: { code: data.value.replaceAll('-', '') } })
        .then(response => {
          const {
            full_name,
            pdv_code,
            pdv_status,
            address,
            city,
            house,
            street,
            zip_code,
            flat
          } = response.data
          if (full_name) {
            const taxNumberInfo = {
              full_name,
              pdv_code,
              pdv_status,
              address,
              city,
              house,
              street,
              zip_code,
              flat
            }
            if (data.isVatForm) {
              result = taxNumberInfo
            } else {
              commit('SET_CONTACTS_FORM', { taxNumberInfo })
            }
          } else {
            if (!data.isVatForm) {
              commit('SET_CONTACTS_FORM', { taxNumberInfo: { error: true } })
            }
          }
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
        .finally(() => {
          if (!data.isVatForm) {
            commit('SET_LOADING_COMPONENTS', { contactsForm: false })
          }
        })
      return result
    },
    SET_CONTACTS_LEGAL ({ commit, dispatch }, data) {
      commit('SET_CONTACTS_FORM', { isLegalPerson: data })
      if (!data) {
        commit('SET_CONTACTS_FORM', { taxNumberInfo: {} })
        commit('SET_CONTACTS_FORM', { taxNumber: '' })
      }
    },
    SET_TAX_NUMBER ({ commit, dispatch }, data) {
      commit('SET_CONTACTS_FORM', { taxNumber: data })
    },
    VALIDATE_NAME_AND_LAST_NAME ({ commit, rootGetters }, { value, inputType }) {
      const { translations } = rootGetters

      const regSpec = new RegExp('[!@#№/$%^&*(),.?":;_=+{}|<>]')
      // const regLatin = new RegExp(/[a-z]/i)
      const regRus = new RegExp(/[\u0400-\u04FF]/)
      const regNum = new RegExp(/\d/)
      const regSpace = new RegExp(/\s/g)
      // const regIsLetterExclude = new RegExp(/[^а-яїіёєґ`‘’'/-]/i)
      const regApostrophes = new RegExp(/[`‘’']/g)
      let error = ''
      const trimmedValue = value.replace(regSpace, '')
      const valueWithoutApostrophes = value.replace(regApostrophes, '')

      if (/^-+$/.test(value)) {
        error = translations('blank_field_error')
      }
      // if (regIsLetterExclude.test(value)) {
      //   error = translations('blank_field_error')
      // }
      if (regSpace.test(value)) {
        error = translations('field_contains_space')
      }
      // if (regLatin.test(value)) {
      //   error = translations('field_contains_latin_letter')
      // }
      if (regRus.test(value)) {
        error = translations('field_contains_cyrillic')
      }
      if (regNum.test(value)) {
        error = translations('field_contains_numbers')
      }
      if (regSpec.test(value) || (trimmedValue.match('--') && trimmedValue.match('--').length)) {
        error = translations('field_contains_special_characters')
      }
      if (
        value.match(regApostrophes) &&
        (value.match(regApostrophes).length > 2 || valueWithoutApostrophes.length < 2)
      ) {
        error = translations('field_contains_special_characters')
      }

      const currentInputError = {}
      currentInputError[inputType] = error

      commit('SET_INVALID_FIELDS', currentInputError)
    },
    SET_CONTACTS_FORM_FIELDS_FROM_SERVER ({ commit, dispatch, rootState, state }, userData) {
      const { name, last_name: lastName, email, phone } = userData
      const { contactsFormData } = state

      if (name && !contactsFormData.name) dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: name, inputType: 'name' })
      if (lastName && !contactsFormData.lastName) {
        dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: lastName, inputType: 'lastName' })
      }
      if (email && !contactsFormData.email) commit('SET_CONTACTS_FORM', { email })
      if (phone && !contactsFormData.phone) {
        // dispatch('SET_FORM_DATA', { phone }, { root: true })
        commit('SET_CONTACTS_FORM', { phone })
      }
    },
    SET_CONTACTS_FORM_FIELDS_FROM_STORAGE ({ commit, dispatch, rootState }) {
      const { formData } = rootState.checkout
      const { name, lastName, city, email, recipientName, recipientLastName, recipientPhone, phone, recipientEmail } = formData

      if (name) dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: name, inputType: 'name' })
      if (lastName) dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: lastName, inputType: 'lastName' })
      if (city?.id) commit('SET_CONTACTS_FORM', { city })
      if (email) commit('SET_CONTACTS_FORM', { email })
      if (phone) commit('SET_CONTACTS_FORM', { phone })
      if (recipientName) commit('SET_CONTACTS_FORM', { recipientName })
      if (recipientEmail) commit('SET_CONTACTS_FORM', { recipientEmail })
      if (recipientLastName) commit('SET_CONTACTS_FORM', { recipientLastName })
      if (recipientPhone) commit('SET_CONTACTS_FORM', { recipientPhone })
    },
    SET_INVALID_FIELDS_ACTION ({ commit }, data) {
      commit('SET_INVALID_FIELDS', data)
    },
    SET_CONTACTS_CITY_ACTION ({ commit, dispatch }, data) {
      commit('SET_CONTACTS_FORM', { city: data })
      commit('SET_INVALID_FIELDS', { city: false })
      dispatch('FETCH_DELIVERY_TYPES', data.id)
    },
    FETCH_DELIVERY_CITIES: ({ commit, rootGetters, rootState, dispatch }, city) => {
      const params = city ? { city } : {}
      commit('SET_LOADING_COMPONENTS', { selectCity: true }, { root: true })

      if (city && city.length < 2) {
        commit('SET_DELIVERY_CITIES', [])
        commit('SET_LOADING_COMPONENTS', { selectCity: false })
        return
      }
      return new Promise(resolve => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/get-cities/', { params })
          .then(response => {
            const { data } = response

            commit('SET_DELIVERY_CITIES', data)

            if (data.user_delivery_city?.id) commit('SET_LAST_SELECTED_CITY', data.user_delivery_city.id)

            if (data.user_delivery_city?.id && !rootState.checkout.formData.city?.id) {
              commit('SET_CONTACTS_FORM', { city: data.user_delivery_city })
              if (window.location.pathname.includes('checkout')) {
                dispatch('FETCH_DELIVERY_TYPES', data.user_delivery_city.id)
              } else if (rootState.checkout.isManagerPage && rootState.checkout.managersClientData.city?.id) {
                commit('SET_CONTACTS_FORM', { city: rootState.checkout.managersClientData.city })
                dispatch('FETCH_DELIVERY_TYPES', rootState.checkout.managersClientData.city.id)
              }
            } else if (!rootState.checkout.formData.city?.id && rootGetters.getActualUserCity) {
              const { getActualUserCity } = rootGetters
              const id = getActualUserCity?.['city_id'] ?? ''
              const name = getActualUserCity.name ?? ''

              if (window.location.pathname.includes('checkout') && id && name) {
                commit('SET_CONTACTS_FORM', { city: { id, name } })
                dispatch('FETCH_DELIVERY_TYPES', id)
              }
            }
            resolve(data)
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
          .finally(() => commit('SET_LOADING_COMPONENTS', { selectCity: false }))
      })
    },
    FETCH_DELIVERY_TYPES ({ commit, rootGetters, rootState, dispatch, state }, cityId) {
      commit('SET_LOADING_COMPONENTS', { deliveryForm: true })
      commit('SET_IS_FORM_HIDDEN', false)
      commit('SET_IS_FORM_SUBMITTED', false)
      const deliveryCity = rootState.deliveryForm.deliveryCity || rootState.geoLocation.userCity

      const params = {}
      if (cityId || deliveryCity?.id) {
        params.cityId = cityId || deliveryCity?.id
      }
      if (deliveryCity.name) {
        params.cityName = deliveryCity.name
      }
      if (deliveryCity.original_name) {
        params.cityName = deliveryCity.original_name
      }
      // if (!deliveryCity.name && !cityId) {
      //   params.getAllMethods = true
      // }
      // if (deliveryCity.zipCode) {
      //   params.cityZipCode = deliveryCity.zipCode
      // }

      if (rootState.checkout.isManagerPage) params.checkout_as_client = true

      return new Promise(resolve => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/method/', { params })
          .then(response => {
            // if (response.data.city_id) {
            //   // console.log(response.data.city_id)
            //   dispatch('SET_DELIVERY_CITY', {
            //     zipCode: deliveryCity.zipCode,
            //     name: deliveryCity.name,
            //     id: response.data.city_id,
            //     uid: deliveryCity.uid || ''
            //   }, { root: true })
            // }
            const deliveryType = { ...rootState?.checkout?.formData?.deliveryType }
            const haveSelectedMethod = response.data.delivery_methods.find(el => el.method_id === deliveryType?.methodId)
            if (!haveSelectedMethod) {
              commit('REDUCE_FORM_DATA', { deliveryType: null })
            }
            const optionsArray = []
            // Формирует массив для отрисовки списка методов доставки
            response.data.delivery_methods.forEach((type, i) => {
              const {
                delivery_cost: deliveryCost,
                full_cost: fullCost,
                method_id: methodId,
                title,
                method_status: status,
                unavailability_reason_message: disabledInfo,
                exceptions = []
              } = type

              if (params.getAllMethods) {
                optionsArray.push({ methodId, title, status: false, deliveryCost, disabledInfo, fullCost, alwaysFreeDelivery: true })
              } else {
                optionsArray.push({ methodId, title, status, deliveryCost, disabledInfo, fullCost, exceptions })
              }

              commit('SET_DELIVERY_TYPES', optionsArray)

              // Подставляет значение полей доставки если есть информация по последнему заказу
              if (
                !deliveryType &&
                !rootState.deliveryForm.lastDeliveryInfo &&
                response.data.user_delivery_method &&
                methodId === response.data.user_delivery_method.id
              ) {
                commit('REDUCE_FORM_DATA', { deliveryType: optionsArray[i] })
                dispatch('SET_LAST_DELIVERY_INFO_ACTION', {
                  id: response.data.user_delivery_method.id,
                  ...response.data.user_delivery_method_info
                })
                dispatch('FETCH_DELIVERY_INFO', { cityId, methodId }).then(() => {
                  const storeUid = rootState?.checkout?.formData?.deliveryInfo?.deliverySpot?.uid ?? null

                  dispatch('GET_FULL_CART', {
                    notUpdateCheckout: true,
                    deliveryType: methodId,
                    storeUid
                  })
                  dispatch('FETCH_PAYMENT_TYPE', { cityId, methodId, storeUid })
                  dispatch('SUBMIT_DELIVERY')
                })
              }
              if (deliveryType?.methodId === methodId && !status) {
                // Обнуляет значение поля метода доставки если метод стал недоступным
                commit('REDUCE_FORM_DATA', { deliveryType: null })
              }

              // Если условия в методе доставки изменились, меняем их на актуальные
              const formattedTypeFromServer = { methodId, title, status, deliveryCost, disabledInfo }
              if (deliveryType?.methodId === methodId && !isEqual(deliveryType, formattedTypeFromServer)) {
                commit('REDUCE_FORM_DATA', { deliveryType: formattedTypeFromServer })
              }
            })
            commit('SET_CURRENCY', response.data.currency)

            if (rootGetters.isDeliveryFormValid) dispatch('SUBMIT_DELIVERY', { root: true })

            resolve(optionsArray)
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
          .finally(() => commit('SET_LOADING_COMPONENTS', { deliveryForm: false }))
      })
    },
    SET_IS_CONTACT_FORM_HIDDEN_ACTION ({ commit }, data) {
      commit('SET_IS_CONTACT_FORM_HIDDEN', data)
    },
    SET_CONTACTS_EMAIL_ACTION ({ commit }, data) {
      commit('SET_CONTACTS_FORM', { email: data })
    },
    SET_CONTACTS_RECIPIENT_EMAIL_ACTION ({ commit }, data) {
      commit('SET_CONTACTS_FORM', { recipientEmail: data })
    },
    SET_CONTACTS_RECIPIENT_PHONE_ACTION ({ commit }, data) {
      commit('SET_CONTACTS_FORM', { recipientPhone: data })
    },
    SET_CONTACTS_PHONE_ACTION ({ commit }, data) {
      commit('SET_CONTACTS_FORM', { phone: data })
    },
    SET_CONTACT_FORM_EMPTY_ACTION ({ commit }, bool) {
      commit('SET_CONTACT_FORM_EMPTY', bool)
    },
    SET_RECIPIENT_PHONE_ACTION ({ commit }, recipientPhone) {
      commit('SET_CONTACTS_FORM', { recipientPhone })
    }
  }
}
